<template>
  <div
    :style="{
      width: grid.cols * 75 - grid.cols + 'px !important',
      height: grid.rows * 75 - grid.rows + 'px !important',
      //top: '50%',
      left: '50%',
      transform: 'translate(-50%,0)',
    }"
    class="content"
  >
    <div v-if="grid.cells != ''">
      <div v-for="r of grid.rows" :key="r">
        <div v-for="c of grid.cols" :key="c">
          <CA
            :col="c"
            :row="r"
            :dta="giveMeValue(r, c)"
            :showrep="showRep"
            :assisted="gAssisted"
            :val="grid.result['r' + c + r]"
            :creation="gCreation"
            @change="doChange"
          />
        </div>
      </div>
    </div>
    <template v-else>Pas de grille sélectionnée !</template>
  </div>
</template>

<script>
import compCase from "./compCase.vue";
export default {
  name: "compGrid",
  data() {
    return {
      showRep: false,
      gAssisted: false,
      gCreation: false,
      grid: {},
    };
  },
  props: ["showrep", "assisted", "grille", "creation"],

  watch: {
    showrep: {
      handler() {
        this.doShowRep();
      },
      deep: true,
      immediate: true,
    },
    assisted: {
      handler() {
        this.doAssisted();
      },
      deep: true,
      immediate: true,
    },
    grille: {
      handler() {
        // console.log(this.grille);
        //raz all
        // this.grid = {};
        // setTimeout(() => {
        //set new grid...
        this.grid = this.grille || {};
        // }, 50);
      },
      deep: true,
      immediate: true,
    },
    creation: {
      handler() {
        this.gCreation = this.creation || {};
      },
      deep: true,
      immediate: true,
    },
  },

  created() {},

  mounted() {
    this.doResult();
  },

  components: {
    CA: compCase,
  },

  computed: {},

  methods: {
    doResult() {
      this.grid.result = {};
      for (var r = 1; r <= this.grid.rows; r++) {
        for (var c = 1; c <= this.grid.cols; c++) {
          this.grid.result["r" + c + r] = "";
        }
      }
    },

    doShowRep() {
      if (this.$props.showrep != undefined) {
        this.showRep = this.$props.showrep;
      }
    },

    doAssisted() {
      if (this.$props.assisted != undefined) {
        this.gAssisted = this.$props.assisted;
      }
    },

    replaceAt(val, index, replacement) {
      return (
        val.substring(0, index) +
        replacement +
        val.substring(index + replacement.length)
      );
    },

    doChange(ret) {
      // console.log(ret);
      this.grid.result["r" + ret.col + ret.row] = ret.val;
      this.grid.cells["c" + ret.col + ret.row] = ret.dta;

      // if (typeof ret.dta == "string") {
      //   // c'est une "réponse"
      //   // var v = this.grid.value[ret.row - 1];
      //   // v = this.replaceAt(v, ret.col - 1, ret.dta);
      //   // this.grid.value[ret.row - 1] = v;

      // } else {
      //   // c'est un label
      //   // v = this.grid.value[ret.row - 1];
      //   // v = this.replaceAt(v, ret.col - 1, "*");
      //   // this.grid.value[ret.row - 1] = v;
      //   // this.grid.label["c" + ret.col + ret.row] = ret.dta;

      //   this.grid.cells["c" + ret.col + ret.row] = {
      //     type: "label",
      //     value: ret.dta,
      // }
    },

    giveMeValue(r, c) {
      var ret = this.grid.cells["c" + c + r];
      return ret;
      // switch (ret.type) {
      //   case "label":
      //     return {
      //       type: "label",
      //       val: ret.value,
      //     };
      //   default:
      //     return ret.value;
      // }
    },

    showModal(m) {
      this.$refs[m].show();
    },

    hideModal(m) {
      this.$refs[m].hide();
    },
  },
};
</script>

<style>
.content {
  position: absolute;
}
</style>
